<template>
<v-app v-if="initialized">
  <v-toolbar fixed app class="main-menu" tabs color="primary" dark height="50px">
    <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/cases">{{ $t("main-menu.cases.title") }}</router-link>
    </div>
    <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/cases/create">{{ $t("main-menu.cases-create.title") }}</router-link>
    </div>
    <div class="main-menu-item">
      <router-link color="blue lighten-5" to="/cases/creation-orders">{{ $t("main-menu.cases-creation-orders.title") }}</router-link>
    </div>
    <v-spacer></v-spacer>
      <div class="guide-button">
          <v-tooltip bottom>
            <i class="fas fa-book" slot="activator" @click="handleGuideClick" style="cursor: pointer; font-size: 31px; margin-right: 15px;"></i>
            <span>{{ $t("main-menu.guide-button.tooltip") }}</span>
          </v-tooltip>
      </div>
      <div class="code-scanner-status">
          <v-tooltip bottom>
            <i class="fas fa-barcode" slot="activator" v-bind:class="{ blink: scanning }"></i>
            <span>{{ $t("main-menu.code-scanner-status.tooltip") }}</span>
          </v-tooltip>
      </div>
      <v-divider vertical></v-divider>
      <div class="ml-3 mr-3 current-client-title">{{ currentClient.title }}</div>
      <v-menu v-model="menu"
              :close-on-content-click="false"
              fixed>
          <v-btn slot="activator" flat>
              {{ user.name }}
          </v-btn>
          <v-card>
              <v-list>
                  <v-list-tile>
                      <v-list-tile-content>
                          <v-list-tile-title>{{ user.name }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                  </v-list-tile>
              </v-list>

              <v-divider></v-divider>

              <v-list class="clinic-menu">
                  <v-list-tile
                          class="clinic-menu-item"
                          v-for="(client) in availableClients"
                          :key="client.id"
                          :disabled="client.id == currentClient.id"
                          :class="{active: client.id == currentClient.id}"
                          @click="handleChangeClient(client.id)">
                      <v-list-tile-title>{{ client.title }}</v-list-tile-title>
                  </v-list-tile>
              </v-list>

              <v-divider></v-divider>

              <v-card-actions>
                  <v-btn block flat @click="handleLogoutClick">{{ $t("main-menu.logout.title") }}</v-btn>
              </v-card-actions>
          </v-card>
      </v-menu>
  </v-toolbar>
    <template>
        <vue-snotify></vue-snotify>
        <div class="content-wrapper">
            <router-view></router-view>
        </div>
    </template>
</v-app>
<v-app v-else>
    <v-container fill-height>
        <v-layout row wrap align-center>
            <v-flex class="text-xs-center">
                <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
</v-app>
</template>

<script>

  import {mapActions, mapState} from 'vuex'
  import 'moment-duration-format'
  import BarcodeScannerHandler from './components/mixins/BarcodeScannerHandler'

  export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      menu: false
    }
  },
  mixins: [BarcodeScannerHandler],
  computed: {
    ...mapState({
      initialized: 'initialized',
      currentClient: 'currentClient',
      availableClients: 'availableClients',
      user: 'user',
      scanning: state => state.caseCreationOrders.scanning
    }),
    language () {
      return this.user.language
    }
  },
  async created() {
    this.getDPUrl()
  },
  methods: {
    ...mapActions({
      initApplication: 'initApplication',
      changeClient: 'changeClient',
      logout: 'logout',
      caseCreationOrdersScanMaterialCode: 'caseCreationOrdersScanMaterialCode',
      getDPUrl: 'fetchDPUrlActions'
    }),
    handleChangeClient (clientId) {
      this.changeClient(clientId)
      this.menu = false;
    },
    handleLogoutClick () {
      this.logout()
      this.$router.push('logout')
      this.menu = false
    },
    handleCodeScanned: function (code) {
      this.caseCreationOrdersScanMaterialCode({vue: this, code: code})
    },
    handleGuideClick: function () {
      window.open('/portal-mcc-guide.pdf', '_blank')
    }
  },
  watch: {
    language: function() {
        this.$i18n.locale = this.language
    }
  },
  mounted () {
    this.initApplication()
  }

}
</script>


<style>
    .main-menu .main-menu-item {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        font-size: 14px;
        font-weight: 500;
        height: inherit;
        line-height: normal;
        max-width: 264px;
        text-align: center;
        text-transform: uppercase;
        vertical-align: middle;
        cursor: pointer;
    }
    .main-menu .main-menu-item a.router-link-exact-active {
        border-bottom: solid 2px #b3d4fc;
        opacity: 1
    }
    .main-menu .main-menu-item a {
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-select: none;
        -ms-flex-align: center;
        align-items: center;
        color: inherit;
        display: -ms-flexbox;
        display: flex;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        height: 100%;
        -ms-flex-pack: center;
        justify-content: center;
        max-width: inherit;
        padding: 6px 12px;
        text-decoration: none;
        transition: .3s cubic-bezier(.25,.8,.5,1);
        user-select: none;
        white-space: normal;
        opacity: .7;
        border-bottom: solid 2px transparent;
    }

    .main-menu .current-client-title {
        font-size: 13px;
        opacity: .8;
    }

    .clinic-menu .clinic-menu-item {
    }

    .clinic-menu .clinic-menu-item.active {
        color: #1976d2;
    }

    .content-wrapper {
        margin-top: 50px;
    }

    .code-scanner-status {
        font-size: 31px;
        margin-right: 15px;
    }

    .blink {
        animation: blink 0.5s steps(5, start) infinite;
        -webkit-animation: blink 0.5s steps(5, start) infinite;
    }
    @keyframes blink {
        to {
            color: #ff5252;
        }
    }
    @-webkit-keyframes blink {
        to {
            color: #ff5252;
        }
    }

</style>
